import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_BANK_ROUTING_CODES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_BANK_ROUTING_CODE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_BANK_ROUTING_CODE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_BANK_ROUTING_CODE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_BANK_ROUTING_CODE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
